<div class="core_cont_chat">
  <h3 class="screen_out">채팅</h3>
  <ul class="list_chat" #messageContainer>
    @for (item of messageList$(); track $index) {
      <core-chat-chat-item [message]="item" [userName]="userName$ | async"></core-chat-chat-item>
    }
  </ul>
</div>
